"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSvg = exports.DEFAULT_ICON_SIZE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const styled_components_1 = __importDefault(require("styled-components"));
exports.DEFAULT_ICON_SIZE = 24; // px
exports.StyledSvg = styled_components_1.default.svg `
  fill: ${({ color, theme }) => color || theme.palette.primary.main};
`;
const IconContainer = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: rotate(
    ${(props) => (props.rotation ? `${props.rotation}deg` : 0)}
  );
  background-color: ${(props) => props.circleDecorator
    ? props.circleDecoratorColor || props.theme.palette.gray[0]
    : "transparent"};
  border-radius: ${(props) => (props.circleDecorator ? "100%" : 0)};
  padding: ${({ size = exports.DEFAULT_ICON_SIZE, circleDecorator }) => circleDecorator ? `${size * 0.25}px` : 0};
  height: ${(props) => (props.circleDecorator ? `${props.size}px` : undefined)};
  width: ${(props) => (props.circleDecorator ? `${props.size}px` : undefined)};
`;
function withContainer(Component) {
    return function WithContainer({ circleDecorator, circleDecoratorColor, rotation, size, ...rest }) {
        const r = (0, common_buoy_theme_1.useResponsive)();
        const defaultIconSize = r({ xs: 24, lg: 36 }) || exports.DEFAULT_ICON_SIZE;
        const iconSize = size || defaultIconSize;
        return ((0, jsx_runtime_1.jsx)(IconContainer, { circleDecorator: circleDecorator, circleDecoratorColor: circleDecoratorColor, className: "BuoyIcon-Container", rotation: rotation, size: iconSize, children: (0, jsx_runtime_1.jsx)(Component, { size: circleDecorator ? iconSize * 0.55 : iconSize, ...rest }) }));
    };
}
exports.default = withContainer;
//# sourceMappingURL=index.js.map